/** @format */

import { Button, Icon, Box } from "@chakra-ui/react";
import { useState } from "react";
import { FaShareAlt } from "react-icons/fa";
import { RWebShare } from "../../ShareList";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { useSession } from "../../../context/useSession";
import { shareImage } from "../../../services/api";
import { useFirebase } from "../../../context/useFirebase";

export function ShareButton({ produto, descricao = false }) {
  const {
    nomeoferta,
    valorde,
    valorpor,
    idtiporecomendacao,
    percentualdesconto,
  } = produto;

  const {
    personalizacao,
    personalizacao: { card },
  } = usePersonalizacao();
  const { session } = useSession();
  const { analyticsEvent } = useFirebase();

  const [isShared, setIsShared] = useState(false);
  const [urlSharedMessage, setUrlSharedMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const formatMessage = () => {
    let valordeFormatted =
      valorde &&
      `${Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valorde)}`;
    let valorporFormatted =
      valorpor &&
      `${Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valorpor)}`;
    let percentualFormatted =
      percentualdesconto &&
      `${Intl.NumberFormat("pt-BR", {
        style: "percent",
        maximumFractionDigits: 2,
      }).format(percentualdesconto / 100)}`;
    let displayName = personalizacao?.displayname;
    let urlappgoogle = personalizacao?.urlappgoogle;
    let urlappapple = personalizacao?.urlappapple;

    let messageTabloide = valorde
      ? `
    ⏰ *Alerta de Oferta:* ${nomeoferta} de ${valordeFormatted} *por apenas ${valorporFormatted}.*
    Baixe o app ${displayName} e receba benefícios exclusivos!\nGoogle: ${urlappgoogle}\nApple: ${urlappapple}
    `
      : `⏰ *Alerta de Oferta:* ${nomeoferta} *por apenas ${valorporFormatted}.*
    Baixe o app ${displayName} e receba benefícios exclusivos!\nGoogle: ${urlappgoogle}\nApple: ${urlappapple}
    `;

    let messageDesconto = `
    ⏰ *Alerta de Desconto Exclusivo 🎟️:* ${nomeoferta} com *${percentualFormatted} de desconto.*
    Não perca, baixe agora o app ${displayName} e ative essa oferta.\nGoogle: ${urlappgoogle}\nApple: ${urlappapple}
    `;

    let messageCashback = `
    ⏰ *Alerta de Cashback 💰:* ${nomeoferta} por apenas *${valorporFormatted}* com *${percentualFormatted} de cashback.*
    Baixe o app ${displayName} e receba benefícios exclusivos!\nGoogle: ${urlappgoogle}\nApple: ${urlappapple}
    `;

    let message;

    function formatMessage(string) {
      return string
        .replace(/@displayname/g, displayName)
        .replace(/@nomeoferta/g, nomeoferta)
        .replace(/@valorde/g, valordeFormatted)
        .replace(/@valorpor/g, valorporFormatted)
        .replace(/@percentual/g, percentualFormatted)
        .replace(/@urlappgoogle/g, urlappgoogle)
        .replace(/@urlappapple/g, urlappapple);
    }

    if (idtiporecomendacao === "2") {
      if (
        !card?.textoCompartilhamento?.tabloide &&
        !card?.textoCompartilhamento?.tabloideSemValorDe
      ) {
        message = messageTabloide;
      } else {
        if (valorde) {
          message = formatMessage(card?.textoCompartilhamento?.tabloide);
        } else {
          message = formatMessage(
            card?.textoCompartilhamento?.tabloideSemValorDe,
          );
        }
      }
    }
    if (idtiporecomendacao === "3") {
      if (!card?.textoCompartilhamento?.cashback) {
        message = messageCashback;
      } else {
        message = formatMessage(card?.textoCompartilhamento?.cashback);
      }
    }
    if (idtiporecomendacao === "1") {
      if (!card?.textoCompartilhamento?.desconto) {
        message = messageDesconto;
      } else {
        message = formatMessage(card?.textoCompartilhamento?.desconto);
      }
    }

    if (/Win|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return message;
    }

    return window.encodeURIComponent(message);
  };

  const handleShare = async () => {
    setIsLoading(true);
    const response = await shareImage("share", {
      headers: {
        idvarejista: session.idvarejista,
        "x-api-key": session.xapikey,
      },
      data: {
        productInfo: produto,
        personalizacao: personalizacao,
      },
    });
    setUrlSharedMessage(response.data.staticPage);

    setIsShared(true);
    document.getElementById("button-share").click();
    analyticsEvent("compartilhaoferta");
    setIsLoading(false);
  };

  if (isShared) {
    return (
      <RWebShare
        onClick={() => setIsShared(false)}
        data={{
          title: "Compartilhar",
          text:
            urlSharedMessage +
            (/Win|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
              ? "\n\n"
              : window.encodeURIComponent("\n\n")) +
            formatMessage(),
          url:
            urlSharedMessage +
            (/Win|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
              ? "\n\n"
              : window.encodeURIComponent("\n\n")),
        }}
        closeText="Fechar">
        <Button
          id="button-share"
          width={descricao ? "50px" : "40px"}
          height={descricao ? "50px" : "40px"}
          borderRadius="full">
          <Icon as={FaShareAlt} />
        </Button>
      </RWebShare>
    );
  }

  if (card.compartilharOferta === false) {
    return (
      <Box
        width={descricao ? "50px" : "40px"}
        height={descricao ? "50px" : "40px"}
        borderRadius="full"
      />
    );
  }

  return (
    <Button
      isLoading={isLoading}
      width={descricao ? "50px" : "40px"}
      height={descricao ? "50px" : "40px"}
      borderRadius="full"
      onClick={handleShare}>
      <Icon as={FaShareAlt} color="#555861" />
    </Button>
  );
}
